//#region IMPORT
import React, { useEffect, useMemo } from 'react';
import { Dialog, Button } from '../../../../Components/MUIs';
import { Box, Typography, Paper, Divider } from '@mui/material';
import dayjs from 'dayjs';
//#endregion

function formatDt(v) {
  if (!v) return '-';
  const d = dayjs(v);
  if (!d.isValid()) return String(v);
  return d.format('YYYY-MM-DD HH:mm');
}

function TRA_CUSTOM_02_ReturnHistoryModal({ open, onClose, rows = [] }) {
  const list = Array.isArray(rows) ? rows : [];
  const normalized = useMemo(
    () =>
      list.map((r, idx) => ({
        seq: r?.seq ?? r?.Seq ?? idx + 1,
        returnId: r?.returnId ?? r?.ReturnId ?? '',
        returnNm: r?.returnNm ?? r?.ReturnNm ?? '',
        returnDate: r?.returnDate ?? r?.ReturnDate ?? '',
        returnDetail: r?.returnDetail ?? r?.ReturnDetail ?? '',
      })),
    [list]
  );

  useEffect(() => {
    if (!open) return;
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          반려 이력
        </Typography>
      }
      useCloseButton={false}
      useSaveButton={false}
      fullWidth
      maxWidth="sm"
      contentSx={{ pt: 1, pb: 2, px: 2 }}
      content={
        <Box>
          {normalized.length === 0 ? (
            <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
              반려 이력이 없습니다.
            </Typography>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
              {normalized.map((r) => (
                <Paper
                  key={String(r.seq)}
                  variant="outlined"
                  sx={{ p: 1.5, borderColor: '#e0e0e0' }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'baseline',
                      gap: 1,
                      mb: 0.75,
                      flexWrap: 'wrap',
                    }}
                  >
                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                      {r.returnNm
                        ? `${r.returnId || '-'} (${r.returnNm})`
                        : r.returnId || '-'}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {formatDt(r.returnDate)}
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 1 }} />
                  <Typography
                    variant="body2"
                    sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
                  >
                    {r.returnDetail || '-'}
                  </Typography>
                </Paper>
              ))}
            </Box>
          )}

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 1.5,
              mt: 2,
              flexWrap: 'wrap',
            }}
          >
            <Button
              name="닫기"
              variant="outlined"
              onClick={onClose}
              sx={{ minWidth: 88 }}
            />
          </Box>
        </Box>
      }
    />
  );
}

export default TRA_CUSTOM_02_ReturnHistoryModal;

